/* Layout */
import Layout from '../../views/layout/Layout.vue'

const CPCCampaignList = () => import(/* webpackChunkName: "cpc-campaign-list" */ '@/views/cpc-campaign/list')
const CPCCampaignDetail = () => import(/* webpackChunkName: "cpc-campaign-detail" */ '@/views/cpc-campaign/detail')

export default [
  {
    path: '/cpc-campaign',
    component: Layout,
    redirect: '/cpc-campaign/list',
    name: 'CPC Campaign',
    alwaysShow: true,
    meta: {
      title: 'cpcCampaign',
      icon: 'images',
    },
    children: [
      {
        path: 'create',
        component: CPCCampaignDetail,
        name: 'CPCCampaignCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'cpc-campaign',
        },
      },
      {
        path: 'edit/:id',
        component: CPCCampaignDetail,
        props: true,
        name: 'CPCCampaignEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'cpc-campaign',
        },
      },
      {
        path: 'list',
        component: CPCCampaignList,
        name: 'CPCCampaignList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'cpc-campaign',
        },
      },
    ],
  },
]
